import { TableV2 } from '@anytag/shared-atoms';
import { TikTokAdReportType } from '@anytag/graphql';
import {
  AdCampaignReportTableProps,
  useAdCampaignReportTable,
  useAdCampaignDownloadReport,
  AdCampaignDownloadReportProps
} from './hooks';
import { ActionBar } from './ActionBar';
import { formatTiktokAdCampaignReportData } from './utils';

export const AdCampaignReportTable = ({
  filter,
  loading,
  summaryData,
  adReportType,
  allTiktokAdsReport,
  adCampaignIdFromUrl
}: Pick<
  AdCampaignReportTableProps,
  'summaryData' | 'allTiktokAdsReport' | 'adReportType' | 'loading' | 'adCampaignIdFromUrl'
> &
  Pick<AdCampaignDownloadReportProps, 'filter'>) => {
  const { downloading, downloadOptions, handleDownloadReport, allItemIds, selectedItemIds, onClickCampaignId } =
    useAdCampaignDownloadReport({
      filter,
      allItemIds: allTiktokAdsReport
        .map((rep) =>
          adReportType === TikTokAdReportType.AD_CAMPAIGN
            ? rep.adCampaignId
            : adReportType === TikTokAdReportType.AD_GROUP
              ? rep.adGroupId
              : rep.adId
        )
        .filter((v) => v !== null && v !== undefined),
      adReportType
    });
  const { columns } = useAdCampaignReportTable({
    summaryData,
    adReportType,
    allTiktokAdsReport,
    adCampaignIdFromUrl,
    selectedAdCampaignIds: selectedItemIds,
    onClickCampaignId
  });

  return (
    <TableV2
      maxHeight="820px"
      loading={loading}
      columns={columns}
      rowHeight="73px"
      className="report-table relative"
      data={formatTiktokAdCampaignReportData(allTiktokAdsReport, summaryData?.summary)}
      hasColumnCustomization
      noTopBorderRadius
      stickyHeader
      hasBorder
    >
      <ActionBar
        selectedIds={selectedItemIds}
        hasAllItemsSelected={allItemIds.length === selectedItemIds.length}
        toggleSelectAllItems={() => onClickCampaignId(selectedItemIds)}
        loading={downloading}
        allItemIds={allItemIds}
        downloadOptions={downloadOptions}
        handleDownloadReport={handleDownloadReport}
      />
    </TableV2>
  );
};
